document.addEventListener("DOMContentLoaded", function () {
  const drawer = document.querySelector("[data-menu-drawer]");
  const openBtn = document.querySelector("[data-menu-toggle]");
  const closeBtns = document.querySelectorAll("[data-menu-close]");

  if (openBtn) {
    openBtn.addEventListener("click", () => {
      drawer.classList.add("is-active");
    });
  }

  closeBtns.forEach(btn => {
    btn.addEventListener("click", () => {
      drawer.classList.remove("is-active");
    });
  });

  const header = document.getElementById('site-header');

  let lastScrollY = 0;

  window.addEventListener('scroll', () => {
    const currentScrollY = window.scrollY;

    if (!header) return;

    if (currentScrollY > 40) {
      header.classList.add('is-sticky');
    } else {
      header.classList.remove('is-sticky');
      header.classList.remove('is-hidden');
    }

    if (currentScrollY > lastScrollY && currentScrollY > 40) {
      header.classList.add('is-hidden');
    }

    if (currentScrollY < lastScrollY) {
      header.classList.remove('is-hidden');
    }

    lastScrollY = currentScrollY;
  });
});